require('../position/position.css');
module.exports = require('./index-nocss.js');



//////////////////
// WEBPACK FOOTER
// ../~/angular-ui-bootstrap/src/modal/index.js
// module id = 513
// module chunks = 0